{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Άκυρο",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Ενοποιήσεις",
    "DESCRIPTION": "Το Κέντρο Επικοινωνίας συνδέεται με πολλά εργαλεία και υπηρεσίες για να βελτιώσει την αποδοτικότητα της ομάδας σας. Δείτε την παρακάτω λίστα για να ρυθμίσετε τις αγαπημένες σας εφαρμογές.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Εγγεγραμμένα Συμβάντα",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Άκυρο",
        "DESC": "Τα συμβάντα Webhook μας εφοδιάζουν με πληροφορίες πραγματικού χρόνου σχετικά με το τι συμβαίνει στο λογαριασμό σας. Παρακαλώ εισάγετε ένα έγκυρο URL στην σχετική ρύθμιση.",
        "SUBSCRIPTIONS": {
          "LABEL": "Συμβάντα",
          "EVENTS": {
            "INBOX_CREATED": "Δημιουργία Κιβωτίου Εισερχομένων",
            "CONVERSATION_CREATED": "Δημιουργήθηκε Συνομιλία",
            "CONVERSATION_STATUS_CHANGED": "Η κατάσταση της συνομιλίας άλλαξε",
            "CONVERSATION_UPDATED": "Η Συνομιλία Ενημερώθηκε",
            "MESSAGE_CREATED": "Δημιουργήθηκε Μήνυμα",
            "MESSAGE_UPDATED": "Το μήνυμα ενημερώθηκε",
            "WEBWIDGET_TRIGGERED": "Το widget συνομιλίας άνοιξε από τον χρήστη",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "JARABOT_EVENT": "Internal events"
          }
        },
        "END_POINT": {
          "LABEL": "Σύνδεσμος Webhook",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Παρακαλώ εισάγετε ένα έγκυρο URL"
        },
        "EDIT_SUBMIT": "Ενημέρωση Webhook",
        "ADD_SUBMIT": "Δημιουργία Webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Διαμόρφωση",
      "HEADER": "Ρυθμίσεις Webhook",
      "HEADER_BTN_TXT": "Προσθήκη Webhook",
      "LOADING": "Λήψη σχετικών webhooks",
      "SEARCH_404": "Δεν υπάρχουν δεδομένα που να ταιριάζουν με αυτό το ερώτημα",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Τα Webhooks είναι κλήσεις HTTP οι οποίες μπορούν να οριστούν για κάθε λογαριασμό. Ενεργοποιούνται από συμβάντα όπως για παράδειγμα την έναρξη μια συνομιλίας. Μπορείτε να δημιουργείσετε πάνω από ένα για τον λογαριασμό σας. <br /><br /> Για την δημιουργία ενός <b>webhook</b>, Πατήστε στο κουμπί <b>Προσθήκη webhook</b>. Μπορείτε επίσης να αφαιρέσετε ένα υπάρχων webhook πατώντας στο σχετική κουμπί Διαγραφή.</p>",
      "LIST": {
        "404": "Δεν έχουν δημιουργηθεί webhooks για αυτόν το λογαριασμό.",
        "TITLE": "Διαχείριση webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "ΣΥΝΔΕΣΜΟΣ Webhook",
          "ACTIONS": "Ενέργειες"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Επεξεργασία",
        "TITLE": "Επεξεργασία webhook",
        "API": {
          "SUCCESS_MESSAGE": "Οι ρυθμίσεις του Webhook ενημερώθηκαν με επιτυχία",
          "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
        }
      },
      "ADD": {
        "CANCEL": "Άκυρο",
        "TITLE": "Προσθήκη Νέου webhook",
        "API": {
          "SUCCESS_MESSAGE": "Η διαμόρφωση Webhook προστέθηκε με επιτυχία",
          "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Διαγραφή",
        "API": {
          "SUCCESS_MESSAGE": "Το Webhook διαγράφηκε επιτυχώς",
          "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
        },
        "CONFIRM": {
          "TITLE": "Επιβεβαίωση Διαγραφής",
          "MESSAGE": "Είστε βέβαιοι να διαγράψετε το webhook? ({webhookURL})",
          "YES": "Ναι, Διέγραψε ",
          "NO": "Όχι, Κράτησε τον/την"
        }
      },
      "DISABLED_BADGE": "Απενεργοποιημένο",
      "DISABLED_REASON": "Αυτόματη απενεργοποίηση μετά από {count} διαδοχικές αποτυχίες. Τελευταίο σφάλμα: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Ενεργοποίηση",
        "API": {
          "SUCCESS_MESSAGE": "Το webhook ενεργοποιήθηκε επιτυχώς",
          "ERROR_MESSAGE": "Δεν ήταν δυνατή η ενεργοποίηση του webhook, παρακαλώ προσπαθήστε ξανά αργότερα"
        }
      }
    },
    "SLACK": {
      "DELETE": "Διαγραφή",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Χρήση Slack Integration",
        "BODY": "Με αυτή την ενσωμάτωση, όλες οι εισερχόμενες συνομιλίες σας θα συγχρονίζονται με το κανάλι ***{selectedChannelName}*** στον χώρο εργασίας σας στο Slack. Μπορείτε να διαχειρίζεστε όλες τις συνομιλίες με τους πελάτες σας μέσα από το κανάλι και να μη χάνετε κανένα μήνυμα.\n\nΑυτά είναι τα βασικά χαρακτηριστικά της ενσωμάτωσης:\n\n**Απαντήστε σε συνομιλίες μέσα από το Slack:** Για να απαντήσετε σε μια συνομιλία στο κανάλι Slack ***{selectedChannelName}***, γράψτε το μήνυμά σας και στείλτε το ως νήμα. Έτσι δημιουργείται μια απάντηση προς τον πελάτη μέσω του Κέντρου Επικοινωνίας. Τόσο απλό!\n\n **Δημιουργήστε ιδιωτικές σημειώσεις:** Αν θέλετε να δημιουργήσετε ιδιωτικές σημειώσεις αντί για απαντήσεις, ξεκινήστε το μήνυμά σας με ***`note:`***. Έτσι το μήνυμά σας μένει ιδιωτικό και ο πελάτης δεν το βλέπει.\n\n**Συσχετίστε ένα προφίλ πράκτορα:** Αν το άτομο που απάντησε στο Slack έχει προφίλ πράκτορα στο Κέντρο Επικοινωνίας με το ίδιο email, οι απαντήσεις συσχετίζονται αυτόματα με αυτό το προφίλ πράκτορα. Έτσι βλέπετε εύκολα ποιος είπε τι και πότε. Αν το άτομο που απάντησε δεν έχει συσχετισμένο προφίλ πράκτορα, ο πελάτης βλέπει τις απαντήσεις από το προφίλ του bot.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "Ενημέρωση",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "Ο χώρος εργασίας σας στο Slack είναι πλέον συνδεδεμένος με το Κέντρο Επικοινωνίας. Όμως η ενσωμάτωση είναι προς το παρόν ανενεργή. Για να ενεργοποιήσετε την ενσωμάτωση και να συνδέσετε ένα κανάλι, κάντε κλικ στο παρακάτω κουμπί.\n\n**Σημείωση:** Αν προσπαθείτε να συνδέσετε ένα ιδιωτικό κανάλι, προσθέστε την εφαρμογή μας στο κανάλι Slack πριν συνεχίσετε με αυτό το βήμα.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Assist",
      "WITH_AI": " {option} με AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Πρόταση απάντησης",
        "SUMMARIZE": "Περίληψη",
        "REPHRASE": "Βελτίωση κειμένου",
        "FIX_SPELLING_GRAMMAR": "Διόρθωση ορθογραφίας και γραμματικής",
        "SHORTEN": "Συντόμευση κειμένου",
        "EXPAND": "Επέκταση",
        "MAKE_FRIENDLY": "Αλλαγή του τόνου του μηνύματος σε φιλικό",
        "MAKE_FORMAL": "Χρήση επίσημου τόνου",
        "SIMPLIFY": "Απλοποίηση",
        "TRANSLATE": "Μετάφραση",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Μετάφραση στην κυρίαρχη γλώσσα"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Περιεχόμενο πρόχειρου",
        "GENERATED_TITLE": "Δημιουργημένο περιεχόμενο",
        "AI_WRITING": "Το AI γράφει",
        "BUTTONS": {
          "APPLY": "Χρήση αυτής της πρότασης",
          "CANCEL": "Άκυρο"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Ενσωμάτωση με το OpenAI",
        "DESC": "Φέρτε προηγμένες λειτουργίες AI στο dashboard σας με τα μοντέλα GPT του OpenAI. Για να ξεκινήσετε, εισάγετε το κλειδί API από τον λογαριασμό σας στο OpenAI.",
        "KEY_PLACEHOLDER": "Εισάγετε το κλειδί API του OpenAI",
        "BUTTONS": {
          "NEED_HELP": "Χρειάζεστε βοήθεια;",
          "DISMISS": "Dismiss",
          "FINISH": "Ολοκλήρωση διαμόρφωσης"
        },
        "DISMISS_MESSAGE": "Μπορείτε να διαμορφώσετε την ενσωμάτωση με το OpenAI αργότερα, όποτε θέλετε.",
        "SUCCESS_MESSAGE": "Η ενσωμάτωση με το OpenAI διαμορφώθηκε με επιτυχία."
      },
      "TITLE": "Βελτίωση με AI",
      "SUMMARY_TITLE": "Περίληψη με AI",
      "REPLY_TITLE": "Πρόταση απάντησης με AI",
      "SUBTITLE": "Θα δημιουργηθεί μια βελτιωμένη απάντηση χρησιμοποιώντας AI, με βάση το τρέχον πρόχειρό σας.",
      "TONE": {
        "TITLE": "Τόνος",
        "OPTIONS": {
          "PROFESSIONAL": "Επαγγελματικός",
          "FRIENDLY": "Φιλικός"
        }
      },
      "BUTTONS": {
        "GENERATE": "Δημιουργία",
        "GENERATING": "Δημιουργία...",
        "CANCEL": "Άκυρο"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Διαγραφή",
      "API": {
        "SUCCESS_MESSAGE": "Η ενοποίηση διαγράφηκε επιτυχώς"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Σύνδεση"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Εφαρμογές Dashboard",
      "HEADER_BTN_TXT": "Προσθήκη νέας εφαρμογής Dashboard",
      "SIDEBAR_TXT": "<p><b>Εφαρμογές Dashboard</b></p><p>Οι εφαρμογές Dashboard επιτρέπουν σε οργανισμούς να ενσωματώσουν μια εφαρμογή μέσα στο ταμπλό για να παρέχουν το πλαίσιο για τους πράκτορες υποστήριξης πελατών. Αυτό το χαρακτηριστικό σας επιτρέπει να δημιουργήσετε μια εφαρμογή ανεξάρτητα και ενσωματωμένη που μέσα στον πίνακα ελέγχου για να παρέχει πληροφορίες χρήστη, τις παραγγελίες τους, ή το ιστορικό προηγούμενων πληρωμών τους.</p><p>Όταν ενσωματώσετε την εφαρμογή σας στο ταμπλό, η εφαρμογή σας θα πάρει το πλαίσιο της συνομιλίας και θα επικοινωνήσει ως ένα παράθυρο εκδήλωσης. Εφαρμόστε έναν ακροατή για το γεγονός του μηνύματος στη σελίδα σας για να λάβετε το πλαίσιο.</p><p>Για να προσθέσετε μια νέα εφαρμογή ταμπλό, κάντε κλικ στο κουμπί 'Προσθήκη μιας νέας εφαρμογής Dashboard'.</p>",
      "DESCRIPTION": "Οι εφαρμογές Dashboard επιτρέπουν στους οργανισμούς να ενσωματώσουν μια εφαρμογή μέσα στον πίνακα ελέγχου για να παρέχουν το περιεχόμενο για τους πράκτορες υποστήριξης πελατών. Αυτή η λειτουργία σας επιτρέπει να δημιουργήσετε μια εφαρμογή ανεξάρτητα και ενσωματωμένη που θα παρέχει πληροφορίες χρήστη, τις παραγγελίες τους, ή το ιστορικό προηγούμενων πληρωμών τους.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Δεν έχουν δημιουργηθεί εφαρμογές Dashboard για αυτόν το λογαριασμό",
        "LOADING": "Λήψη εφαρμογών dashboard ...",
        "TABLE_HEADER": {
          "NAME": "Όνομα",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Επεξεργασία εφαρμογής",
        "DELETE_TOOLTIP": "Διαγραφή εφαρμογής"
      },
      "FORM": {
        "TITLE_LABEL": "Όνομα",
        "TITLE_PLACEHOLDER": "Εισάγετε όνομα για την εφαρμογή dashboard",
        "TITLE_ERROR": "Απαιτείται ένα όνομα για την εφαρμογή dashboard",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Εισάγετε το URL του endpoint όπου φιλοξενείται η εφαρμογή σας",
        "URL_ERROR": "Απαιτείται ένα έγκυρο URL"
      },
      "CREATE": {
        "HEADER": "Προσθήκη νέας εφαρμογής Dashboard",
        "FORM_SUBMIT": "Καταχώρηση",
        "FORM_CANCEL": "Άκυρο",
        "API_SUCCESS": "Η εφαρμογή dashboard ρυθμίστηκε επιτυχώς",
        "API_ERROR": "Δεν μπορούμε να δημιουργήσουμε μια εφαρμογή. Παρακαλώ δοκιμάστε ξανά αργότερα"
      },
      "UPDATE": {
        "HEADER": "Επεξεργασία εφαρμογής dashboard",
        "FORM_SUBMIT": "Ενημέρωση",
        "FORM_CANCEL": "Άκυρο",
        "API_SUCCESS": "Η εφαρμογή dashboard ενημερώθηκε με επιτυχία",
        "API_ERROR": "Δεν ήταν δυνατή η ενημέρωση της εφαρμογής. Παρακαλώ δοκιμάστε ξανά αργότερα"
      },
      "DELETE": {
        "CONFIRM_YES": "Ναι, Διέγραψε την",
        "CONFIRM_NO": "Όχι, Κράτησε την",
        "TITLE": "Επιβεβαίωση Διαγραφής",
        "MESSAGE": "Είστε βέβαιοι να διαγράψετε την εφαρμογή - {appName};",
        "API_SUCCESS": "Η εφαρμογή dashboard διαγράφηκε επιτυχώς",
        "API_ERROR": "Δεν μπορούμε να διαγράψουμε την εφαρμογή. Παρακαλώ δοκιμάστε ξανά αργότερα"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Δημιουργία",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Σύνδεσμος",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Τίτλος",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Ο τίτλος είναι απαραίτητος"
          },
          "DESCRIPTION": {
            "LABEL": "Περιγραφή",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Ομάδα",
            "PLACEHOLDER": "Επιλογή ομάδας",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Priority",
            "PLACEHOLDER": "Select priority",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Ετικέτα",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Κατάσταση",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Δημιουργία",
        "CANCEL": "Άκυρο",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Κατάσταση",
        "PRIORITY": "Priority",
        "ASSIGNEE": "Assignee",
        "LABELS": "Ετικέτες",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Άκυρο"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Αποστολή μηνύματος...",
      "EMPTY_MESSAGE": "Παρουσιάστηκε σφάλμα κατά τη δημιουργία της απάντησης. Παρακαλώ προσπαθήστε ξανά.",
      "LOADER": "Captain is thinking",
      "YOU": "You",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Άκυρο",
      "CREATE": "Δημιουργία",
      "EDIT": "Ενημέρωση"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Χαρακτηριστικά",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Διαγραφή",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Όλες"
      },
      "STATUS": {
        "TITLE": "Κατάσταση",
        "PENDING": "Εκκρεμεί",
        "APPROVED": "Approved",
        "ALL": "Όλες"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Αποσύνδεση"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Yes, delete",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Εισερχόμενα",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
